import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { VerticalDivider, DefaultMopViewWrapper, LinkWrapper } from './styled';
import { setModeClickHandler } from './helpers';
import { isEmpty } from '@chegg/utils';
import { ElementType, PaymentMethodsCommandNames, sendRioEvent, SpecType, StatusTypes, SubType } from '@chegg/commerce-utils';
import { doFireStatusUpdate, sendRioEventCallback } from '../../utils/CallbackUtils';
import { Link } from '@chegg-ui/link';
import { useAppSelector } from '../../hooks/useAppSelector';
import { CardTypes } from '../../constants/PaymentTypes';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { getString } from '../../constants/Strings';
import { AppMode } from '../../redux/AppModeState/AppModeState.types';
import { getPaymentFieldLabelText } from '../UserAddress/utils/getPaymentFieldLabelText';
import { PaymentFormDataFields } from '../UserAddress/constants';
import { MopDisplayContent } from '../MopDisplayContent';
import { configSelector, paymenFormSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { paymentMethodsSelector, selectedMopSelector } from '../../redux/MopOnFileState/MopOnFileState.selectors';
import { resetForm } from '../../redux/PaymentState/helpers/resetForm';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.actions';
export var DefaultMopView = function DefaultMopView(props) {
  var paymentForm = useAppSelector(paymenFormSelector);
  var selectedMop = useAppSelector(selectedMopSelector);
  var paymentMethods = useAppSelector(paymentMethodsSelector);
  var config = useAppSelector(configSelector);
  var rioNamespace = config.rioNamespace;
  var dispatch = useDispatch();
  var hostedFieldsService = props.hostedFieldsService;
  useEffect(function () {
    doFireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: PaymentMethodsCommandNames.MOP_SELECTED,
      payload: {
        data: selectedMop
      }
    }]);
  }, [selectedMop]);
  useEffect(function () {
    var multipleMop = paymentMethods.length > 1;
    //Rio logging: Log all of users payment methods
    if (paymentMethods.length > 0) {
      paymentMethods.forEach(function (paymentMethod) {
        var cardType = paymentMethod.type;
        if (!cardType && paymentMethod.accountType === CardTypes.PAYPAL) {
          // in case of paypal, check for accountType
          cardType = 'paypal';
        } else if (!cardType && paymentMethod.accountType === CardTypes.VENMO) {
          // in case of venmo, check for accountType
          cardType = 'venmo';
        }
        sendRioEvent({
          info: getString('APP.RIO.EVENTS.MOP_LOADED'),
          specType: SpecType.COMPONENT_VIEW,
          subType: SubType.COMPONENT,
          callback: sendRioEventCallback,
          namespace: rioNamespace,
          value: cardType,
          force: false
        });
      });
    }

    // If User has multiple mop, show List of mops directly
    if (multipleMop) {
      setModeClickHandler(AppMode.LIST_MOPS, AppMode.DEFAULT_MOP, dispatch);
    }
  }, [paymentMethods]);
  var addPaymentMethodClickHandler = function addPaymentMethodClickHandler(e) {
    e.preventDefault();

    //Rio logging: When user clicks on Add Payment Method CTA
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.ADD_PAYMENT_METHOD_CTA_CLICKED'),
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: sendRioEventCallback,
      namespace: rioNamespace
    });
    setModeClickHandler(AppMode.ADD, AppMode.DEFAULT_MOP, dispatch);
    dispatch(saveConfigs({
      isNewMopAddingToMopList: true
    }));
    resetForm(hostedFieldsService, dispatch);
  };
  var editClickhandler = function editClickhandler(e) {
    e.preventDefault();
    setModeClickHandler(AppMode.EDIT, AppMode.DEFAULT_MOP, dispatch);
  };
  return !isEmpty(selectedMop) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DefaultMopViewWrapper, {
    "data-test": DataTestAttributes.DEFAULT_MOP_VIEW
  }, /*#__PURE__*/React.createElement(MopDisplayContent, {
    mop: selectedMop
  })), /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(Link, {
    "data-test": DataTestAttributes.ADD_PAYMENT_METHOD_LINK,
    hasButtonBehavior: true,
    onClick: addPaymentMethodClickHandler,
    href: '#',
    role: 'button'
  }, getPaymentFieldLabelText(PaymentFormDataFields.ADD_PAYMENT_METHOD, paymentForm) || getString('APP.MOPONFILE.ADD.PAYMENT.METHOD')), selectedMop.canUpdate && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VerticalDivider, null), /*#__PURE__*/React.createElement(Link, {
    "data-test": DataTestAttributes.EDIT_CARD_SELECTION,
    hasButtonBehavior: true,
    href: '#',
    onClick: editClickhandler,
    role: 'button'
  }, getPaymentFieldLabelText(PaymentFormDataFields.EDIT_CARD, paymentForm) || getString('APP.MOPONFILE.EDIT.CARD'))))) : null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/DefaultMopView/index.js
// module id = 4568
// module chunks = 11